import React from "react";
import "./../../A2Page/A2Benefits/A2Benefits.css";
const B1BenefitsMain = () => {
  return (
    <div className="LvlBenefitsMainContainer">
      <ul>
        <li>
          🌟<span>Intermediate Mastery: </span>Achieve an intermediate level of
          fluency, enabling you to express yourself confidently in German.
        </li>
        <li>
          🎓<span> University & Job Ready:</span> Meet the basic requirements
          for most Germany-based organizations and universities, enhancing your
          academic and career prospects.
        </li>
        <li>
          📚 <span>Advanced Grammar:</span> Build upon your A1 and A2 knowledge
          to frame sentences with advanced grammar structures, solidifying your
          language skills.
        </li>
        <li>
          📖 <span>Complex Texts:</span> Learn to frame complexly connected
          texts, improving your written communication abilities.
        </li>
        <li>
          🗣️ <span>Diverse Situations:</span> Handle a wider range of situations
          and vocabulary, making you versatile in various contexts.
        </li>
        <li>
          🌐 <span>Everyday & Professional Use:</span> Use the language
          effectively in both everyday and professional situations, ensuring
          seamless communication.
        </li>
        <li>
          💬 <span>Engaging Topics:</span> Engage in discussions on a variety of
          interesting topics, broadening your conversational horizons.
        </li>
        <li>
          ✨<span> Express Yourself:</span> Describe experiences, events,
          dreams, hopes, and ambitions, adding depth to your conversations.
        </li>
        <li>
          🗨️ <span>Opinions:</span> Develop the ability to briefly give
          opinions, making your interactions more dynamic.
        </li>
        <li>
          📜 <span>Widely Recognized Certificate:</span> Earn a certificate
          recognized by employers as sufficient evidence of German proficiency,
          boosting your resume.
        </li>
        <li>
          🚀 <span>Career Success:</span> Improve your chances of success in the
          job market, opening doors to new opportunities.
        </li>
        <p>
          Join Prizma Academy’s B1 Level German Course in Bangalore and take the
          next step towards fluency, ensuring you're ready for academic,
          professional, and personal success!
        </p>
      </ul>
    </div>
  );
};

export default B1BenefitsMain;
